export default {
  name: 'noticewrap',
  props: {
    mb: {
      type: String,
      default: ''
    },
    txt: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  components: {},
  methods: {},
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};